import { Draft } from "immer";

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";

import { RelatedProductState } from "@tIntermatic/Store/Components/RelatedProductFilter/RelatedProductState";

const initialRelatedProductsFilterState: RelatedProductState = {
    relatedProductsCarouselIdMapping: {}
};

const reducer = {
    "Components/RelatedProductFilter/CompleteRelatedProductFilterIds": (
        draft: Draft<RelatedProductState>,
        action: RelatedProductState,
    ) => {
        draft.relatedProductsCarouselIdMapping[action.relatedProductsCarouselIdMapping.currentProductId] = action.relatedProductsCarouselIdMapping.carouselId
    },
};

export default createTypedReducerWithImmer(initialRelatedProductsFilterState, reducer);
